export var UpdateAccountTypeIA = function UpdateAccountTypeIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    }
  };
};
var getAnswer = function getAnswer(_context, strictLocalize) {
  return {
    getTitle: function getTitle() {
      return UPDATE_ACCOUNT_TYPE(strictLocalize);
    },
    getDescription: function getDescription() {
      return [PLEASE_SEND_US_THE_FOLLOWING_INFO(strictLocalize), FIRST_STEP_TO_UPDATE_ACCOUNT_TYPE(strictLocalize), SECOND_STEP_TO_UPDATE_ACCOUNT_TYPE(strictLocalize), ONCE_WE_RECEIVE_THIS_INFO(strictLocalize)];
    }
  };
};
var UPDATE_ACCOUNT_TYPE = function UPDATE_ACCOUNT_TYPE(strictLocalize) {
  return strictLocalize({
    id: "QzoC6y",
    defaultMessage: "Update account type to “Brick and Mortar”"
  });
};
var PLEASE_SEND_US_THE_FOLLOWING_INFO = function PLEASE_SEND_US_THE_FOLLOWING_INFO(strictLocalize) {
  return strictLocalize({
    id: "oR9T2X",
    defaultMessage: "To get this started, please send us the following information using the contact option(s) provided in the “Contact Us” section:"
  });
};
var FIRST_STEP_TO_UPDATE_ACCOUNT_TYPE = function FIRST_STEP_TO_UPDATE_ACCOUNT_TYPE(strictLocalize) {
  return strictLocalize({
    id: "rAF0hs",
    defaultMessage: "1. The physical address of your brick and mortar shop"
  });
};
var SECOND_STEP_TO_UPDATE_ACCOUNT_TYPE = function SECOND_STEP_TO_UPDATE_ACCOUNT_TYPE(strictLocalize) {
  return strictLocalize({
    id: "MvxnaR",
    defaultMessage: "2. Interior and exterior photos of your shop with your shop sign visible in the exterior photos"
  });
};
var ONCE_WE_RECEIVE_THIS_INFO = function ONCE_WE_RECEIVE_THIS_INFO(strictLocalize) {
  return strictLocalize({
    id: "ElLq0T",
    defaultMessage: "Once we receive this information, our support team will be happy to update your account type or discuss any questions that we might have for you."
  });
};